"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const verifyScopeFormat_1 = __importDefault(require("../../utils/verifyScopeFormat"));
const GraphandFieldText_1 = __importDefault(require("./GraphandFieldText"));
class GraphandFieldScope extends GraphandFieldText_1.default {
    constructor() {
        super(...arguments);
        this.options = [];
    }
    setter(value) {
        if (value !== undefined && value !== null) {
            (0, verifyScopeFormat_1.default)(value);
        }
        return value;
    }
}
exports.default = GraphandFieldScope;
